import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBCard, MDBCardBody, MDBCol, MDBInput, MDBTable } from "mdbreact";
import {
  SetClinicFilter,
  SetSearchKey,
} from "../../../../services/redux/slices/diagnostics/clinic/dailyCollections";
import { getClinicOptions, getCollectionRows, money } from "./utils";

const ListPanel = () => {
  const dispatch = useDispatch();
  const { collections, searchKey, clinicFilter, isLoading } = useSelector(
    ({ dailyCollections }) => dailyCollections,
  );

  const clinicOptions = useMemo(() => getClinicOptions(collections), [collections]);
  const rows = useMemo(
    () => getCollectionRows(collections, searchKey, clinicFilter),
    [collections, searchKey, clinicFilter],
  );

  return (
    <MDBCol md="12">
      <MDBCard>
        <MDBCardBody>
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h5 className="mb-0 font-weight-bold">Collection List</h5>
            <div className="text-muted small">{rows.length} transaction(s)</div>
          </div>

          <div className="d-flex flex-wrap mb-3">
            <div className="flex-grow-1 mr-3" style={{ minWidth: "260px" }}>
              <MDBInput
                label="Search patient, clinic, doctor, queue or item"
                type="text"
                value={searchKey}
                onChange={({ target }) => dispatch(SetSearchKey(target.value))}
                icon="search"
                outline
              />
            </div>
            <div style={{ minWidth: "220px" }}>
              <label className="grey-text">Clinic Filter</label>
              <select
                className="browser-default custom-select"
                value={clinicFilter}
                onChange={({ target }) => dispatch(SetClinicFilter(target.value))}
              >
                <option value="all">All Clinics</option>
                {clinicOptions.map((clinicName) => (
                  <option key={clinicName} value={clinicName}>
                    {clinicName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="table-responsive">
            <MDBTable striped bordered hover>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Patient</th>
                  <th>Clinic</th>
                  <th>Doctor</th>
                  <th>Items</th>
                  <th>Gross</th>
                  <th>Discount</th>
                  <th>Coverage</th>
                  <th>Share</th>
                  <th>Payment</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="10" className="text-center text-muted py-4">
                      Loading daily collections...
                    </td>
                  </tr>
                ) : rows.length ? (
                  rows.map((item) => (
                    <tr key={item._id}>
                      <td>{item.timeLabel}</td>
                      <td>
                        <div className="font-weight-bold">{item.patientName}</div>
                        <div className="text-muted small">
                          QN {item?.appointment?.qn || "--"}
                        </div>
                      </td>
                      <td>{item.clinicName}</td>
                      <td>{item.physicianName}</td>
                      <td style={{ minWidth: "240px" }}>
                        {item.itemLabels.length ? item.itemLabels.join(", ") : "--"}
                      </td>
                      <td>{money(item.gross)}</td>
                      <td>{money(item.discount)}</td>
                      <td>{money(item.coverage)}</td>
                      <td>{money(item.share)}</td>
                      <td className="text-uppercase">{item.payment || "cash"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center text-muted py-4">
                      No collections found for the selected filters.
                    </td>
                  </tr>
                )}
              </tbody>
            </MDBTable>
          </div>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  );
};

export default ListPanel;
